var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCentralLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9264 14.4388C11.9264 14.4388 7.31679 10.3413 7.31679 6.53649C7.31679 2.73169 10.8289 2 11.9264 2C13.024 2 16.7556 2.43902 16.7556 6.53649C16.7556 10.634 11.9264 14.4388 11.9264 14.4388ZM11.9264 14.4388V17.9319M11.9264 14.4388L17.0243 16.6119M11.9264 14.4388L6.41724 16.6119M14.1947 6.60966V6.60966C14.1947 7.82197 13.2119 8.80474 11.9996 8.80474V8.80474C10.7873 8.80474 9.80454 7.82197 9.80454 6.60966V6.60966C9.80454 5.39735 10.7873 4.41458 11.9996 4.41458V4.41458C13.2119 4.41458 14.1947 5.39735 14.1947 6.60966Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.46338,
    cy: 18.0971,
    r: 2.21338,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5365,
    cy: 18.0971,
    r: 2.21338,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9258,
    cy: 20.7315,
    r: 2.21338,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralLocation);
export default __webpack_public_path__ + "static/media/central_location.732eec70914e119f8a252ae85a699b40.svg";
export { ForwardRef as ReactComponent };